import { defineMessages } from 'react-intl';

export const messages: {
	lastModified: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	lastModified: {
		id: 'dynamic-cards-search-page.search-result.last-modified',
		defaultMessage: 'Updated {formattedDate}',
		description: 'This shows the timestamp of when the result was last modified.',
	},
});
